import { render, staticRenderFns } from "./ReturnSchool.vue?vue&type=template&id=61f0d5b1&scoped=true&"
import script from "./ReturnSchool.vue?vue&type=script&lang=js&"
export * from "./ReturnSchool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f0d5b1",
  null
  
)

export default component.exports